import en from './en';
import ro from './ro';
import {flattenObject} from "../utils/objectUtils";

export default {
    ro: flattenObject(ro),
    en: flattenObject(en)
}
